
import Container from "../layouts/Container.vue";
import Home from "../pages/Home.vue";
import StaticPage from "../pages/StaticPage.vue";
import PageNotFound from "../pages/404.vue";
import ErrorPage from "../pages/error.vue";
import ShoppingPickupList from "../pages/ShoppingPickupList.vue";
import ShopList from "../pages/ShopList.vue";
import Menu from "../pages/Menu.vue";
import GuestLogin from "../pages/GuestLogin.vue";
import Checkout from "../pages/Checkout.vue";
import Confirmation from "../pages/Confirmation.vue";
import OrderConfirmationRedirect from "../pages/OrderConfirmationRedirect.vue";

import MemberProfile from "../pages/MemberProfile.vue";
import MembeOrderHistory from "../pages/MembeOrderHistory.vue";
import MembeOrderHistoryDetails from "../pages/MembeOrderHistoryDetails.vue";

import DownloadPage from "../download/DownloadPage.vue";


export default [
    {
        path: '/', component: Container,
        children: [
            { path: '', component: Home },
            { path: 'page/:type/:code', component: StaticPage },
            { path: 'error', component: ErrorPage },
            { path: 'ShoppingPickup', component: ShoppingPickupList },
            { path: 'shop', component: ShopList },
            { path: 'menu', component: Menu },
            {
                path: 'menu/:cateId', component: Menu
            },
            { path: 'guestlogin', component: GuestLogin },
            { path: 'checkout', component: Checkout },
            { path: 'preview', component: Checkout },
            { path: 'confirmation', component: Confirmation },
            { path: 'order_confirmation', component: OrderConfirmationRedirect },

            { path: 'member/profile', component: MemberProfile },
            {
                path: 'member/orderhistory', component: MembeOrderHistory,
                children: [
                    { path: ':orderNo', component: MembeOrderHistoryDetails }
                ]
            },
           
        ]
    }
    , 


    { path: '/download', component: DownloadPage },
    { path: '/shoporder', component: DownloadPage },
    { path: '/eshop', component: DownloadPage },
	{ path: '/orderConfrim', component: DownloadPage },

    { path: '*', component: PageNotFound },

]